import React from 'react';
import { useTranslation } from 'react-i18next';

const ChiSono = () => {
  const { t } = useTranslation();

  return (
    <div className="chi-sono-page">
      <div className="top-bar" />
      <div className="split-layout">
        <div className="split-image" style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_preview-live-18/artifacts/t0llu8fb_unnamed.jpg')`,
        }}>
        </div>

        <div className="split-content">
          <h1 className="page-title">{t('chiSono.title')}</h1>

          <div className="content-text">
            <p>{t('chiSono.p1')}</p>
            <p>
              {t('chiSono.p2Part1')} <strong>{t('chiSono.p2Bold')}</strong>
            </p>
            <p>{t('chiSono.p3')}</p>
            <p>{t('chiSono.p4')}</p>
            <p>{t('chiSono.p5')}</p>
            <p>{t('chiSono.p6')}</p>
            <p><strong>{t('chiSono.p7Bold')}</strong></p>
            <p className="closing-text">{t('chiSono.closing')}</p>
            <p className="signature">{t('chiSono.signature')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChiSono;
